import {
  ERROR_GROUP_BUYING_OVER,
  ERROR_NOT_IN_GROUP_BUYING,
  ERROR_ORDER_CANCELED,
  ERROR_ORDER_HAS_BEEN_TOKEN,
  ERROR_ORDER_NOT_FOUND,
  ERROR_ORDER_OVER_AMOUNT_LIMIT,
  ERROR_ORDER_OVER_ITEM_LIMIT,
  ERROR_ORDER_OVER_LIMIT,
  ERROR_PARAM,
  ERROR_RECEIVE_TIME_ID,
} from '@/utils/errorCodeList';

export default class CustomError extends Error {
  constructor(error) {
    super();

    const { message: axiosMessage, response = {} } = error;
    const { data: { status, message = '' } = {} } = response;

    this.status = status;
    const errorMessage = {
      [ERROR_GROUP_BUYING_OVER]: '無法參與指定的訂購，該訂購可能已截止或取消。如有疑問請洽管理員。',
      [ERROR_NOT_IN_GROUP_BUYING]: '您無法參與此訂購。如有疑問請洽管理員。',
      [ERROR_ORDER_CANCELED]: '訂單已取消，如有疑問請洽管理員。',
      [ERROR_ORDER_HAS_BEEN_TOKEN]: '此訂單已完成領取，如有疑問請洽管理員。',
      [ERROR_ORDER_NOT_FOUND]: '查無此訂單，如有疑問請洽管理員。',
      [ERROR_ORDER_OVER_AMOUNT_LIMIT]: '訂購金額超過上限，請依訂購限制調整後重新送單。',
      [ERROR_ORDER_OVER_ITEM_LIMIT]: '個人總訂購品項數超過上限，請依訂購限制調整後重新送單。',
      [ERROR_ORDER_OVER_LIMIT]: '單一訂購品項數超過上限，請依訂購限制調整後重新送單。',
      [ERROR_PARAM]: '參數設定錯誤，請重試一次。',
      [ERROR_RECEIVE_TIME_ID]: '請選擇領取時間。',
    };
    const unknownError = '雲端伺服器錯誤，請稍後再試。如有疑問請洽管理員。';

    if (axiosMessage === 'Network Error') {
      this.message = '無法連線至伺服器，請檢查您的網路連線。';
    } else if (!status) {
      this.message = unknownError;
    } else {
      this.message = errorMessage[status]
        ? `${errorMessage[status]}(代碼: ${status})`
        : `${message || unknownError}(代碼: ${status})`;
    }

    this.response = error;
  }
}
CustomError.prototype.name = 'CustomError';
